import React from 'react';
import classnames from 'classnames';
import { Trans } from 'react-i18next';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import UserLink from '../../../User/Link/UserLink';
import BasicUserName from '../../../User/BasicUserName';
import { getMoreByLinkType } from '../../helpers';
import s from './MoreByAuthor.scss';
const MoreByAuthor = ({ contentType, author, className })=>{
    const profile_content_anchor = useFlag('profile_content_anchor');
    return /*#__PURE__*/ React.createElement(UserLink, {
        className: classnames(s['root'], className),
        user: author,
        linkTo: getMoreByLinkType(contentType),
        anchor: profile_content_anchor
    }, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: `sidebar.blockTitle.${contentType}`
    }, "More things by ", /*#__PURE__*/ React.createElement(BasicUserName, {
        user: author
    })));
};
MoreByAuthor.displayName = 'MoreByAuthor';
export default MoreByAuthor;

//# sourceMappingURL=MoreByAuthor.js.map